import {TuiContextWithImplicit} from '@taiga-ui/cdk';
import {Observable} from 'rxjs';

export enum UmpireFilterType {
  SELECT = 'select',
  MULTISELECT = 'multiselect',
  DATETIME = 'datetime',
}

export interface UmpireFilterConfig {
  id: string;
  name: string;
  data?: Observable<any[]>;
  stringify?: (selected: TuiContextWithImplicit<any>) => string;
  identityMatcher?: boolean;
  clearable?: boolean;
  type: UmpireFilterType;
  translate?: boolean;
}
